<div class="form-group">
  <label
    *ngIf="!hideLabel"
    [class.success]="showSuccess"
    [for]="inputName"
    class="input-label"
    >{{ labelName }} <span *ngIf="flagAsRequired">*</span></label
  >
  <div
    *ngIf="timeValue?.hour !== -1 && timeValue?.minute !== -1"
    class="input-group mb-3">
    <ngb-timepicker
      [formControl]="value"
      [disabled]="!editable || value?.disabled"
      [spinners]="false">
    </ngb-timepicker>
  </div>
  <app-error-label
    *ngIf="value.invalid && value?.touched"
    [message]="'Invalid ' + labelName"></app-error-label>
</div>
